import config from 'config'
import {

} from 'containers/pages'
import { Main } from 'components/masters'

import { get } from 'lodash'
import React from 'react'
import { renderRoutes } from 'react-router-config'
import { Breadcrumbs, Tabs } from 'components/layout'
import * as Page from 'containers/pages'
import { Redirect } from 'react-router-dom'

const publicPath = config.publicPath
const routes = [
  {
    path: `${publicPath}/leaders`,
    component: props => (
      <Main {...props} params={get(props, 'match.params', {})}>
        { renderRoutes(props.route.routes, {...props}) }
      </Main>
    ),
    routes: [
      {
        path: `${publicPath}/leaders`,
        exact: true,
        component: props => (
          <Page.LeadersList params={get(props, 'match.params', {})} {...props} />
        )
      },

      {
        path: `${publicPath}/leaders/:id`,
        component: props => (
          <Page.Leader
            {...props}
            breadcrumbs={
              <Breadcrumbs {...props} params={get(props, 'match.params', {})} />
            }
            tabs={
              <Tabs {...props} params={get(props, 'match.params', {})} />
            }
          />
        ),
        routes: [
          {
            path: `${publicPath}/leaders/:id`,
            exact: true,
            component: props => (
              <Redirect to={`${publicPath}/leaders/${props.match.params.id}/detail`} />
            )
          },
          {
            path: `${publicPath}/leaders/:id/detail`,
            exact: true,
            component: props => (
              <Page.LeaderDetail params={get(props, 'match.params', {})} {...props} />
            )
          },

          {
            path: `${publicPath}/leaders/:id/participants`,
            exact: true,
            component: props => (
              <Page.LeaderParticipants params={get(props, 'match.params', {})} {...props} />
            )
          },
          {
            path: `${publicPath}/leaders/:id/history`,
            exact: true,
            component: props => (
              <Page.LeaderHistory params={get(props, 'match.params', {})} {...props} />
            )
          }
        ]
      }
    ]
  }
]

export default routes
